import { watchDeleteBigCommerceShipMethod } from './deleteBigCommerceShipMethod';
import { watchDeleteBigCommerceStore } from './deleteBigCommerceStore';
import { watchFetchBigCommerceShipMethods } from './fetchBigCommerceShipMethods';
import { watchFetchBigCommerceStores } from './fetchBigCommerceStores';
import { watchUpdateBigCommerceShipMethods } from './updateBigCommerceShipMethods';
import { watchUpdateBigCommerceStore } from './updateBigCommerceStore';

export const bigCommerceSagas = [
  watchDeleteBigCommerceShipMethod(),
  watchDeleteBigCommerceStore(),
  watchFetchBigCommerceShipMethods(),
  watchFetchBigCommerceStores(),
  watchUpdateBigCommerceShipMethods(),
  watchUpdateBigCommerceStore()
];
